<template>
  <div>
    <canvas
      id="confetti-canvas"
      style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999; pointer-events: none;"
    />
    <b-modal
      v-model="modal"
      class="position-relative"
      lazy
      centered
      scrollable
      body-class="p-4 overflow-y-auto max-h-[90vh]"
      content-class="new-section-modal"
      size="lg"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <h1 class="text-[#151515] text-3xl font-bold text-center mb-3 uppercase">
        🔒 Action Required: Please Review & Accept Our New Service Agreement
      </h1>
  
      <hr class="border-[#E2E8F2] mb-4">
  
      <p class="text-[#040404] text-sm font-medium text-center mb-6">
        To continue using ESTAGE, all users must first review and agree to our updated
        <b>Master Services Agreement (MSA), End User License Agreement (EULA), and Data Processing Agreement (DPA)</b>.
        These terms are designed to protect both you and ESTAGE, clarify your rights, and ensure compliance with global data protection laws.
        Please take a moment to carefully review the agreement and provide your electronic acceptance. Once accepted, you’ll have uninterrupted access to the ESTAGE platform.
      </p>
  
      <embed
        src="pdf/estage-msa-sep-24-2025.pdf#zoom=75&navpanes=0"
        type="application/pdf"
        width="100%"
        height="640px"
      >
  
      <div class="justify-self-center mt-3">
        <div class="flex flex-col">
          <label class="inline-flex items-center text-xs text-gray-500">
            <input
              v-model="check"
              type="checkbox"
              class="!w-4 !h-4 mr-2 text-primary rounded-sm"
              required
            >
            I have read and agree to the Agreement
          </label>
  
          <span
            v-if="showError && !check"
            class="text-red-500 text-[11px] mt-1.5"
          >
            Please agree to the terms before proceeding
          </span>
        </div>
  
        <b-btn
          variant="primary"
          class="w-full h-[44px] mt-4 !font-[600]"
          :disabled="loading || !check"
          @click="handleSubmit"
        >
          Yes, I agree to these terms
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import confetti from 'canvas-confetti'

export default {
  name: 'Agreement',
  data () {
    return {
      loading: false,
      check: false,
      showError: false
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    modal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    confettiAnimation () {
      var end = Date.now() + 1000
      const canvas = document.getElementById('confetti-canvas')
      const confettiRef = confetti.create(canvas, { resize: true });

      (function frame () {
        confettiRef({
          particleCount: 2,
          angle: 45,
          spread: 75,
          origin: { x: 0 }
        })
        confettiRef({
          particleCount: 2,
          angle: 130,
          spread: 75,
          origin: { x: 1 }
        })

        if (Date.now() < end) {
          requestAnimationFrame(frame)
        }
      }())
    },
    async handleSubmit () {
      let aug_26_2025 = null
      const estage_agreement = !!this.user.estage_agreement
      if (estage_agreement) {
        const agreement = JSON.parse(this.user.estage_agreement)
        if (!agreement.sep_24_2025) {
          aug_26_2025 = agreement
        }
      }
      const res = await fetch('https://api.ipify.org?format=json')
      const {ip} = await res.json()
      await axios.put('/api/user/profile/agreement', {
        agreement: JSON.stringify({
          aug_26_2025: aug_26_2025,
          sep_24_2025: {
            accepted: new Date().toISOString(),
            email: this.user.email,
            ip
          }
        })
      })
        .then(() => {
          this.confettiAnimation()
          this.modal = false
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
